(function () {
  const e = document.createElement("link").relList;
  if (e && e.supports && e.supports("modulepreload")) return;
  for (const t of document.querySelectorAll('link[rel="modulepreload"]')) s(t);
  new MutationObserver((t) => {
    for (const a of t)
      if (a.type === "childList")
        for (const r of a.addedNodes)
          r.tagName === "LINK" && r.rel === "modulepreload" && s(r);
  }).observe(document, { childList: !0, subtree: !0 });
  function i(t) {
    const a = {};
    return (
      t.integrity && (a.integrity = t.integrity),
      t.referrerPolicy && (a.referrerPolicy = t.referrerPolicy),
      t.crossOrigin === "use-credentials"
        ? (a.credentials = "include")
        : t.crossOrigin === "anonymous"
        ? (a.credentials = "omit")
        : (a.credentials = "same-origin"),
      a
    );
  }
  function s(t) {
    if (t.ep) return;
    t.ep = !0;
    const a = i(t);
    fetch(t.href, a);
  }
})();
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const oe = globalThis,
  be =
    oe.ShadowRoot &&
    (oe.ShadyCSS === void 0 || oe.ShadyCSS.nativeShadow) &&
    "adoptedStyleSheets" in Document.prototype &&
    "replace" in CSSStyleSheet.prototype,
  _e = Symbol(),
  Ee = new WeakMap();
let ot = class {
  constructor(e, i, s) {
    if (((this._$cssResult$ = !0), s !== _e))
      throw Error(
        "CSSResult is not constructable. Use `unsafeCSS` or `css` instead."
      );
    (this.cssText = e), (this.t = i);
  }
  get styleSheet() {
    let e = this.o;
    const i = this.t;
    if (be && e === void 0) {
      const s = i !== void 0 && i.length === 1;
      s && (e = Ee.get(i)),
        e === void 0 &&
          ((this.o = e = new CSSStyleSheet()).replaceSync(this.cssText),
          s && Ee.set(i, e));
    }
    return e;
  }
  toString() {
    return this.cssText;
  }
};
const ct = (o) => new ot(typeof o == "string" ? o : o + "", void 0, _e),
  g = (o, ...e) => {
    const i =
      o.length === 1
        ? o[0]
        : e.reduce(
            (s, t, a) =>
              s +
              ((r) => {
                if (r._$cssResult$ === !0) return r.cssText;
                if (typeof r == "number") return r;
                throw Error(
                  "Value passed to 'css' function must be a 'css' function result: " +
                    r +
                    ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security."
                );
              })(t) +
              o[a + 1],
            o[0]
          );
    return new ot(i, o, _e);
  },
  pt = (o, e) => {
    if (be)
      o.adoptedStyleSheets = e.map((i) =>
        i instanceof CSSStyleSheet ? i : i.styleSheet
      );
    else
      for (const i of e) {
        const s = document.createElement("style"),
          t = oe.litNonce;
        t !== void 0 && s.setAttribute("nonce", t),
          (s.textContent = i.cssText),
          o.appendChild(s);
      }
  },
  Oe = be
    ? (o) => o
    : (o) =>
        o instanceof CSSStyleSheet
          ? ((e) => {
              let i = "";
              for (const s of e.cssRules) i += s.cssText;
              return ct(i);
            })(o)
          : o;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const {
    is: ht,
    defineProperty: ut,
    getOwnPropertyDescriptor: mt,
    getOwnPropertyNames: ft,
    getOwnPropertySymbols: gt,
    getPrototypeOf: vt,
  } = Object,
  E = globalThis,
  Me = E.trustedTypes,
  $t = Me ? Me.emptyScript : "",
  ue = E.reactiveElementPolyfillSupport,
  V = (o, e) => o,
  se = {
    toAttribute(o, e) {
      switch (e) {
        case Boolean:
          o = o ? $t : null;
          break;
        case Object:
        case Array:
          o = o == null ? o : JSON.stringify(o);
      }
      return o;
    },
    fromAttribute(o, e) {
      let i = o;
      switch (e) {
        case Boolean:
          i = o !== null;
          break;
        case Number:
          i = o === null ? null : Number(o);
          break;
        case Object:
        case Array:
          try {
            i = JSON.parse(o);
          } catch {
            i = null;
          }
      }
      return i;
    },
  },
  we = (o, e) => !ht(o, e),
  Te = {
    attribute: !0,
    type: String,
    converter: se,
    reflect: !1,
    hasChanged: we,
  };
Symbol.metadata ?? (Symbol.metadata = Symbol("metadata")),
  E.litPropertyMetadata ?? (E.litPropertyMetadata = new WeakMap());
class H extends HTMLElement {
  static addInitializer(e) {
    this._$Ei(), (this.l ?? (this.l = [])).push(e);
  }
  static get observedAttributes() {
    return this.finalize(), this._$Eh && [...this._$Eh.keys()];
  }
  static createProperty(e, i = Te) {
    if (
      (i.state && (i.attribute = !1),
      this._$Ei(),
      this.elementProperties.set(e, i),
      !i.noAccessor)
    ) {
      const s = Symbol(),
        t = this.getPropertyDescriptor(e, s, i);
      t !== void 0 && ut(this.prototype, e, t);
    }
  }
  static getPropertyDescriptor(e, i, s) {
    const { get: t, set: a } = mt(this.prototype, e) ?? {
      get() {
        return this[i];
      },
      set(r) {
        this[i] = r;
      },
    };
    return {
      get() {
        return t == null ? void 0 : t.call(this);
      },
      set(r) {
        const c = t == null ? void 0 : t.call(this);
        a.call(this, r), this.requestUpdate(e, c, s);
      },
      configurable: !0,
      enumerable: !0,
    };
  }
  static getPropertyOptions(e) {
    return this.elementProperties.get(e) ?? Te;
  }
  static _$Ei() {
    if (this.hasOwnProperty(V("elementProperties"))) return;
    const e = vt(this);
    e.finalize(),
      e.l !== void 0 && (this.l = [...e.l]),
      (this.elementProperties = new Map(e.elementProperties));
  }
  static finalize() {
    if (this.hasOwnProperty(V("finalized"))) return;
    if (
      ((this.finalized = !0), this._$Ei(), this.hasOwnProperty(V("properties")))
    ) {
      const i = this.properties,
        s = [...ft(i), ...gt(i)];
      for (const t of s) this.createProperty(t, i[t]);
    }
    const e = this[Symbol.metadata];
    if (e !== null) {
      const i = litPropertyMetadata.get(e);
      if (i !== void 0)
        for (const [s, t] of i) this.elementProperties.set(s, t);
    }
    this._$Eh = new Map();
    for (const [i, s] of this.elementProperties) {
      const t = this._$Eu(i, s);
      t !== void 0 && this._$Eh.set(t, i);
    }
    this.elementStyles = this.finalizeStyles(this.styles);
  }
  static finalizeStyles(e) {
    const i = [];
    if (Array.isArray(e)) {
      const s = new Set(e.flat(1 / 0).reverse());
      for (const t of s) i.unshift(Oe(t));
    } else e !== void 0 && i.push(Oe(e));
    return i;
  }
  static _$Eu(e, i) {
    const s = i.attribute;
    return s === !1
      ? void 0
      : typeof s == "string"
      ? s
      : typeof e == "string"
      ? e.toLowerCase()
      : void 0;
  }
  constructor() {
    super(),
      (this._$Ep = void 0),
      (this.isUpdatePending = !1),
      (this.hasUpdated = !1),
      (this._$Em = null),
      this._$Ev();
  }
  _$Ev() {
    var e;
    (this._$ES = new Promise((i) => (this.enableUpdating = i))),
      (this._$AL = new Map()),
      this._$E_(),
      this.requestUpdate(),
      (e = this.constructor.l) == null || e.forEach((i) => i(this));
  }
  addController(e) {
    var i;
    (this._$EO ?? (this._$EO = new Set())).add(e),
      this.renderRoot !== void 0 &&
        this.isConnected &&
        ((i = e.hostConnected) == null || i.call(e));
  }
  removeController(e) {
    var i;
    (i = this._$EO) == null || i.delete(e);
  }
  _$E_() {
    const e = new Map(),
      i = this.constructor.elementProperties;
    for (const s of i.keys())
      this.hasOwnProperty(s) && (e.set(s, this[s]), delete this[s]);
    e.size > 0 && (this._$Ep = e);
  }
  createRenderRoot() {
    const e =
      this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
    return pt(e, this.constructor.elementStyles), e;
  }
  connectedCallback() {
    var e;
    this.renderRoot ?? (this.renderRoot = this.createRenderRoot()),
      this.enableUpdating(!0),
      (e = this._$EO) == null ||
        e.forEach((i) => {
          var s;
          return (s = i.hostConnected) == null ? void 0 : s.call(i);
        });
  }
  enableUpdating(e) {}
  disconnectedCallback() {
    var e;
    (e = this._$EO) == null ||
      e.forEach((i) => {
        var s;
        return (s = i.hostDisconnected) == null ? void 0 : s.call(i);
      });
  }
  attributeChangedCallback(e, i, s) {
    this._$AK(e, s);
  }
  _$EC(e, i) {
    var a;
    const s = this.constructor.elementProperties.get(e),
      t = this.constructor._$Eu(e, s);
    if (t !== void 0 && s.reflect === !0) {
      const r = (
        ((a = s.converter) == null ? void 0 : a.toAttribute) !== void 0
          ? s.converter
          : se
      ).toAttribute(i, s.type);
      (this._$Em = e),
        r == null ? this.removeAttribute(t) : this.setAttribute(t, r),
        (this._$Em = null);
    }
  }
  _$AK(e, i) {
    var a;
    const s = this.constructor,
      t = s._$Eh.get(e);
    if (t !== void 0 && this._$Em !== t) {
      const r = s.getPropertyOptions(t),
        c =
          typeof r.converter == "function"
            ? { fromAttribute: r.converter }
            : ((a = r.converter) == null ? void 0 : a.fromAttribute) !== void 0
            ? r.converter
            : se;
      (this._$Em = t),
        (this[t] = c.fromAttribute(i, r.type)),
        (this._$Em = null);
    }
  }
  requestUpdate(e, i, s) {
    if (e !== void 0) {
      if (
        (s ?? (s = this.constructor.getPropertyOptions(e)),
        !(s.hasChanged ?? we)(this[e], i))
      )
        return;
      this.P(e, i, s);
    }
    this.isUpdatePending === !1 && (this._$ES = this._$ET());
  }
  P(e, i, s) {
    this._$AL.has(e) || this._$AL.set(e, i),
      s.reflect === !0 &&
        this._$Em !== e &&
        (this._$Ej ?? (this._$Ej = new Set())).add(e);
  }
  async _$ET() {
    this.isUpdatePending = !0;
    try {
      await this._$ES;
    } catch (i) {
      Promise.reject(i);
    }
    const e = this.scheduleUpdate();
    return e != null && (await e), !this.isUpdatePending;
  }
  scheduleUpdate() {
    return this.performUpdate();
  }
  performUpdate() {
    var s;
    if (!this.isUpdatePending) return;
    if (!this.hasUpdated) {
      if (
        (this.renderRoot ?? (this.renderRoot = this.createRenderRoot()),
        this._$Ep)
      ) {
        for (const [a, r] of this._$Ep) this[a] = r;
        this._$Ep = void 0;
      }
      const t = this.constructor.elementProperties;
      if (t.size > 0)
        for (const [a, r] of t)
          r.wrapped !== !0 ||
            this._$AL.has(a) ||
            this[a] === void 0 ||
            this.P(a, this[a], r);
    }
    let e = !1;
    const i = this._$AL;
    try {
      (e = this.shouldUpdate(i)),
        e
          ? (this.willUpdate(i),
            (s = this._$EO) == null ||
              s.forEach((t) => {
                var a;
                return (a = t.hostUpdate) == null ? void 0 : a.call(t);
              }),
            this.update(i))
          : this._$EU();
    } catch (t) {
      throw ((e = !1), this._$EU(), t);
    }
    e && this._$AE(i);
  }
  willUpdate(e) {}
  _$AE(e) {
    var i;
    (i = this._$EO) == null ||
      i.forEach((s) => {
        var t;
        return (t = s.hostUpdated) == null ? void 0 : t.call(s);
      }),
      this.hasUpdated || ((this.hasUpdated = !0), this.firstUpdated(e)),
      this.updated(e);
  }
  _$EU() {
    (this._$AL = new Map()), (this.isUpdatePending = !1);
  }
  get updateComplete() {
    return this.getUpdateComplete();
  }
  getUpdateComplete() {
    return this._$ES;
  }
  shouldUpdate(e) {
    return !0;
  }
  update(e) {
    this._$Ej && (this._$Ej = this._$Ej.forEach((i) => this._$EC(i, this[i]))),
      this._$EU();
  }
  updated(e) {}
  firstUpdated(e) {}
}
(H.elementStyles = []),
  (H.shadowRootOptions = { mode: "open" }),
  (H[V("elementProperties")] = new Map()),
  (H[V("finalized")] = new Map()),
  ue == null || ue({ ReactiveElement: H }),
  (E.reactiveElementVersions ?? (E.reactiveElementVersions = [])).push("2.0.4");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const W = globalThis,
  ae = W.trustedTypes,
  Ne = ae ? ae.createPolicy("lit-html", { createHTML: (o) => o }) : void 0,
  st = "$lit$",
  A = `lit$${Math.random().toFixed(9).slice(2)}$`,
  at = "?" + A,
  yt = `<${at}>`,
  L = document,
  Y = () => L.createComment(""),
  q = (o) => o === null || (typeof o != "object" && typeof o != "function"),
  Se = Array.isArray,
  Ct = (o) =>
    Se(o) || typeof (o == null ? void 0 : o[Symbol.iterator]) == "function",
  me = `[ 	
\f\r]`,
  G = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g,
  Ke = /-->/g,
  Le = />/g,
  N = RegExp(
    `>|${me}(?:([^\\s"'>=/]+)(${me}*=${me}*(?:[^ 	
\f\r"'\`<>=]|("|')|))|$)`,
    "g"
  ),
  ze = /'/g,
  je = /"/g,
  rt = /^(?:script|style|textarea|title)$/i,
  bt =
    (o) =>
    (e, ...i) => ({ _$litType$: o, strings: e, values: i }),
  l = bt(1),
  z = Symbol.for("lit-noChange"),
  u = Symbol.for("lit-nothing"),
  Ue = new WeakMap(),
  K = L.createTreeWalker(L, 129);
function nt(o, e) {
  if (!Se(o) || !o.hasOwnProperty("raw"))
    throw Error("invalid template strings array");
  return Ne !== void 0 ? Ne.createHTML(e) : e;
}
const _t = (o, e) => {
  const i = o.length - 1,
    s = [];
  let t,
    a = e === 2 ? "<svg>" : e === 3 ? "<math>" : "",
    r = G;
  for (let c = 0; c < i; c++) {
    const d = o[c];
    let f,
      v,
      h = -1,
      S = 0;
    for (; S < d.length && ((r.lastIndex = S), (v = r.exec(d)), v !== null); )
      (S = r.lastIndex),
        r === G
          ? v[1] === "!--"
            ? (r = Ke)
            : v[1] !== void 0
            ? (r = Le)
            : v[2] !== void 0
            ? (rt.test(v[2]) && (t = RegExp("</" + v[2], "g")), (r = N))
            : v[3] !== void 0 && (r = N)
          : r === N
          ? v[0] === ">"
            ? ((r = t ?? G), (h = -1))
            : v[1] === void 0
            ? (h = -2)
            : ((h = r.lastIndex - v[2].length),
              (f = v[1]),
              (r = v[3] === void 0 ? N : v[3] === '"' ? je : ze))
          : r === je || r === ze
          ? (r = N)
          : r === Ke || r === Le
          ? (r = G)
          : ((r = N), (t = void 0));
    const P = r === N && o[c + 1].startsWith("/>") ? " " : "";
    a +=
      r === G
        ? d + yt
        : h >= 0
        ? (s.push(f), d.slice(0, h) + st + d.slice(h) + A + P)
        : d + A + (h === -2 ? c : P);
  }
  return [
    nt(
      o,
      a + (o[i] || "<?>") + (e === 2 ? "</svg>" : e === 3 ? "</math>" : "")
    ),
    s,
  ];
};
class Z {
  constructor({ strings: e, _$litType$: i }, s) {
    let t;
    this.parts = [];
    let a = 0,
      r = 0;
    const c = e.length - 1,
      d = this.parts,
      [f, v] = _t(e, i);
    if (
      ((this.el = Z.createElement(f, s)),
      (K.currentNode = this.el.content),
      i === 2 || i === 3)
    ) {
      const h = this.el.content.firstChild;
      h.replaceWith(...h.childNodes);
    }
    for (; (t = K.nextNode()) !== null && d.length < c; ) {
      if (t.nodeType === 1) {
        if (t.hasAttributes())
          for (const h of t.getAttributeNames())
            if (h.endsWith(st)) {
              const S = v[r++],
                P = t.getAttribute(h).split(A),
                ie = /([.?@])?(.*)/.exec(S);
              d.push({
                type: 1,
                index: a,
                name: ie[2],
                strings: P,
                ctor:
                  ie[1] === "."
                    ? St
                    : ie[1] === "?"
                    ? Dt
                    : ie[1] === "@"
                    ? xt
                    : re,
              }),
                t.removeAttribute(h);
            } else
              h.startsWith(A) &&
                (d.push({ type: 6, index: a }), t.removeAttribute(h));
        if (rt.test(t.tagName)) {
          const h = t.textContent.split(A),
            S = h.length - 1;
          if (S > 0) {
            t.textContent = ae ? ae.emptyScript : "";
            for (let P = 0; P < S; P++)
              t.append(h[P], Y()),
                K.nextNode(),
                d.push({ type: 2, index: ++a });
            t.append(h[S], Y());
          }
        }
      } else if (t.nodeType === 8)
        if (t.data === at) d.push({ type: 2, index: a });
        else {
          let h = -1;
          for (; (h = t.data.indexOf(A, h + 1)) !== -1; )
            d.push({ type: 7, index: a }), (h += A.length - 1);
        }
      a++;
    }
  }
  static createElement(e, i) {
    const s = L.createElement("template");
    return (s.innerHTML = e), s;
  }
}
function R(o, e, i = o, s) {
  var r, c;
  if (e === z) return e;
  let t = s !== void 0 ? ((r = i._$Co) == null ? void 0 : r[s]) : i._$Cl;
  const a = q(e) ? void 0 : e._$litDirective$;
  return (
    (t == null ? void 0 : t.constructor) !== a &&
      ((c = t == null ? void 0 : t._$AO) == null || c.call(t, !1),
      a === void 0 ? (t = void 0) : ((t = new a(o)), t._$AT(o, i, s)),
      s !== void 0 ? ((i._$Co ?? (i._$Co = []))[s] = t) : (i._$Cl = t)),
    t !== void 0 && (e = R(o, t._$AS(o, e.values), t, s)),
    e
  );
}
class wt {
  constructor(e, i) {
    (this._$AV = []), (this._$AN = void 0), (this._$AD = e), (this._$AM = i);
  }
  get parentNode() {
    return this._$AM.parentNode;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  u(e) {
    const {
        el: { content: i },
        parts: s,
      } = this._$AD,
      t = ((e == null ? void 0 : e.creationScope) ?? L).importNode(i, !0);
    K.currentNode = t;
    let a = K.nextNode(),
      r = 0,
      c = 0,
      d = s[0];
    for (; d !== void 0; ) {
      if (r === d.index) {
        let f;
        d.type === 2
          ? (f = new J(a, a.nextSibling, this, e))
          : d.type === 1
          ? (f = new d.ctor(a, d.name, d.strings, this, e))
          : d.type === 6 && (f = new Pt(a, this, e)),
          this._$AV.push(f),
          (d = s[++c]);
      }
      r !== (d == null ? void 0 : d.index) && ((a = K.nextNode()), r++);
    }
    return (K.currentNode = L), t;
  }
  p(e) {
    let i = 0;
    for (const s of this._$AV)
      s !== void 0 &&
        (s.strings !== void 0
          ? (s._$AI(e, s, i), (i += s.strings.length - 2))
          : s._$AI(e[i])),
        i++;
  }
}
class J {
  get _$AU() {
    var e;
    return ((e = this._$AM) == null ? void 0 : e._$AU) ?? this._$Cv;
  }
  constructor(e, i, s, t) {
    (this.type = 2),
      (this._$AH = u),
      (this._$AN = void 0),
      (this._$AA = e),
      (this._$AB = i),
      (this._$AM = s),
      (this.options = t),
      (this._$Cv = (t == null ? void 0 : t.isConnected) ?? !0);
  }
  get parentNode() {
    let e = this._$AA.parentNode;
    const i = this._$AM;
    return (
      i !== void 0 &&
        (e == null ? void 0 : e.nodeType) === 11 &&
        (e = i.parentNode),
      e
    );
  }
  get startNode() {
    return this._$AA;
  }
  get endNode() {
    return this._$AB;
  }
  _$AI(e, i = this) {
    (e = R(this, e, i)),
      q(e)
        ? e === u || e == null || e === ""
          ? (this._$AH !== u && this._$AR(), (this._$AH = u))
          : e !== this._$AH && e !== z && this._(e)
        : e._$litType$ !== void 0
        ? this.$(e)
        : e.nodeType !== void 0
        ? this.T(e)
        : Ct(e)
        ? this.k(e)
        : this._(e);
  }
  O(e) {
    return this._$AA.parentNode.insertBefore(e, this._$AB);
  }
  T(e) {
    this._$AH !== e && (this._$AR(), (this._$AH = this.O(e)));
  }
  _(e) {
    this._$AH !== u && q(this._$AH)
      ? (this._$AA.nextSibling.data = e)
      : this.T(L.createTextNode(e)),
      (this._$AH = e);
  }
  $(e) {
    var a;
    const { values: i, _$litType$: s } = e,
      t =
        typeof s == "number"
          ? this._$AC(e)
          : (s.el === void 0 &&
              (s.el = Z.createElement(nt(s.h, s.h[0]), this.options)),
            s);
    if (((a = this._$AH) == null ? void 0 : a._$AD) === t) this._$AH.p(i);
    else {
      const r = new wt(t, this),
        c = r.u(this.options);
      r.p(i), this.T(c), (this._$AH = r);
    }
  }
  _$AC(e) {
    let i = Ue.get(e.strings);
    return i === void 0 && Ue.set(e.strings, (i = new Z(e))), i;
  }
  k(e) {
    Se(this._$AH) || ((this._$AH = []), this._$AR());
    const i = this._$AH;
    let s,
      t = 0;
    for (const a of e)
      t === i.length
        ? i.push((s = new J(this.O(Y()), this.O(Y()), this, this.options)))
        : (s = i[t]),
        s._$AI(a),
        t++;
    t < i.length && (this._$AR(s && s._$AB.nextSibling, t), (i.length = t));
  }
  _$AR(e = this._$AA.nextSibling, i) {
    var s;
    for (
      (s = this._$AP) == null ? void 0 : s.call(this, !1, !0, i);
      e && e !== this._$AB;

    ) {
      const t = e.nextSibling;
      e.remove(), (e = t);
    }
  }
  setConnected(e) {
    var i;
    this._$AM === void 0 &&
      ((this._$Cv = e), (i = this._$AP) == null || i.call(this, e));
  }
}
class re {
  get tagName() {
    return this.element.tagName;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  constructor(e, i, s, t, a) {
    (this.type = 1),
      (this._$AH = u),
      (this._$AN = void 0),
      (this.element = e),
      (this.name = i),
      (this._$AM = t),
      (this.options = a),
      s.length > 2 || s[0] !== "" || s[1] !== ""
        ? ((this._$AH = Array(s.length - 1).fill(new String())),
          (this.strings = s))
        : (this._$AH = u);
  }
  _$AI(e, i = this, s, t) {
    const a = this.strings;
    let r = !1;
    if (a === void 0)
      (e = R(this, e, i, 0)),
        (r = !q(e) || (e !== this._$AH && e !== z)),
        r && (this._$AH = e);
    else {
      const c = e;
      let d, f;
      for (e = a[0], d = 0; d < a.length - 1; d++)
        (f = R(this, c[s + d], i, d)),
          f === z && (f = this._$AH[d]),
          r || (r = !q(f) || f !== this._$AH[d]),
          f === u ? (e = u) : e !== u && (e += (f ?? "") + a[d + 1]),
          (this._$AH[d] = f);
    }
    r && !t && this.j(e);
  }
  j(e) {
    e === u
      ? this.element.removeAttribute(this.name)
      : this.element.setAttribute(this.name, e ?? "");
  }
}
class St extends re {
  constructor() {
    super(...arguments), (this.type = 3);
  }
  j(e) {
    this.element[this.name] = e === u ? void 0 : e;
  }
}
class Dt extends re {
  constructor() {
    super(...arguments), (this.type = 4);
  }
  j(e) {
    this.element.toggleAttribute(this.name, !!e && e !== u);
  }
}
class xt extends re {
  constructor(e, i, s, t, a) {
    super(e, i, s, t, a), (this.type = 5);
  }
  _$AI(e, i = this) {
    if ((e = R(this, e, i, 0) ?? u) === z) return;
    const s = this._$AH,
      t =
        (e === u && s !== u) ||
        e.capture !== s.capture ||
        e.once !== s.once ||
        e.passive !== s.passive,
      a = e !== u && (s === u || t);
    t && this.element.removeEventListener(this.name, this, s),
      a && this.element.addEventListener(this.name, this, e),
      (this._$AH = e);
  }
  handleEvent(e) {
    var i;
    typeof this._$AH == "function"
      ? this._$AH.call(
          ((i = this.options) == null ? void 0 : i.host) ?? this.element,
          e
        )
      : this._$AH.handleEvent(e);
  }
}
class Pt {
  constructor(e, i, s) {
    (this.element = e),
      (this.type = 6),
      (this._$AN = void 0),
      (this._$AM = i),
      (this.options = s);
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AI(e) {
    R(this, e);
  }
}
const fe = W.litHtmlPolyfillSupport;
fe == null || fe(Z, J),
  (W.litHtmlVersions ?? (W.litHtmlVersions = [])).push("3.2.1");
const At = (o, e, i) => {
  const s = (i == null ? void 0 : i.renderBefore) ?? e;
  let t = s._$litPart$;
  if (t === void 0) {
    const a = (i == null ? void 0 : i.renderBefore) ?? null;
    s._$litPart$ = t = new J(e.insertBefore(Y(), a), a, void 0, i ?? {});
  }
  return t._$AI(o), t;
};
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ let m = class extends H {
  constructor() {
    super(...arguments),
      (this.renderOptions = { host: this }),
      (this._$Do = void 0);
  }
  createRenderRoot() {
    var i;
    const e = super.createRenderRoot();
    return (
      (i = this.renderOptions).renderBefore ?? (i.renderBefore = e.firstChild),
      e
    );
  }
  update(e) {
    const i = this.render();
    this.hasUpdated || (this.renderOptions.isConnected = this.isConnected),
      super.update(e),
      (this._$Do = At(i, this.renderRoot, this.renderOptions));
  }
  connectedCallback() {
    var e;
    super.connectedCallback(), (e = this._$Do) == null || e.setConnected(!0);
  }
  disconnectedCallback() {
    var e;
    super.disconnectedCallback(), (e = this._$Do) == null || e.setConnected(!1);
  }
  render() {
    return z;
  }
};
var it;
(m._$litElement$ = !0),
  (m.finalized = !0),
  (it = globalThis.litElementHydrateSupport) == null ||
    it.call(globalThis, { LitElement: m });
const ge = globalThis.litElementPolyfillSupport;
ge == null || ge({ LitElement: m });
(globalThis.litElementVersions ?? (globalThis.litElementVersions = [])).push(
  "4.1.1"
);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $ = (o) => (e, i) => {
  i !== void 0
    ? i.addInitializer(() => {
        customElements.define(o, e);
      })
    : customElements.define(o, e);
};
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const Et = {
    attribute: !0,
    type: String,
    converter: se,
    reflect: !1,
    hasChanged: we,
  },
  Ot = (o = Et, e, i) => {
    const { kind: s, metadata: t } = i;
    let a = globalThis.litPropertyMetadata.get(t);
    if (
      (a === void 0 && globalThis.litPropertyMetadata.set(t, (a = new Map())),
      a.set(i.name, o),
      s === "accessor")
    ) {
      const { name: r } = i;
      return {
        set(c) {
          const d = e.get.call(this);
          e.set.call(this, c), this.requestUpdate(r, d, o);
        },
        init(c) {
          return c !== void 0 && this.P(r, void 0, o), c;
        },
      };
    }
    if (s === "setter") {
      const { name: r } = i;
      return function (c) {
        const d = this[r];
        e.call(this, c), this.requestUpdate(r, d, o);
      };
    }
    throw Error("Unsupported decorator location: " + s);
  };
function n(o) {
  return (e, i) =>
    typeof i == "object"
      ? Ot(o, e, i)
      : ((s, t, a) => {
          const r = t.hasOwnProperty(a);
          return (
            t.constructor.createProperty(a, r ? { ...s, wrapped: !0 } : s),
            r ? Object.getOwnPropertyDescriptor(t, a) : void 0
          );
        })(o, e, i);
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function p(o) {
  return n({ ...o, state: !0, attribute: !1 });
}
var Mt = Object.defineProperty,
  j = (o, e, i, s) => {
    for (var t = void 0, a = o.length - 1, r; a >= 0; a--)
      (r = o[a]) && (t = r(e, i, t) || t);
    return t && Mt(e, i, t), t;
  };
let O = class extends m {
  constructor() {
    super(...arguments),
      (this.currentIndex = 0),
      (this.selectedSDK = null),
      (this.SDKManager = []),
      (this.isPopUpOpen = !1);
  }
};
j([n({ type: Object })], O.prototype, "data");
j([p()], O.prototype, "currentIndex");
j([p()], O.prototype, "calendar");
j([p()], O.prototype, "form");
j([p()], O.prototype, "selectedSDK");
j([p()], O.prototype, "SDKManager");
j([p()], O.prototype, "isPopUpOpen");
var Tt = Object.defineProperty,
  De = (o, e, i, s) => {
    for (var t = void 0, a = o.length - 1, r; a >= 0; a--)
      (r = o[a]) && (t = r(e, i, t) || t);
    return t && Tt(e, i, t), t;
  };
let ne = class extends m {
  constructor() {
    super(...arguments), (this.selectedSDK = 0), (this.SDKManager = []);
  }
};
De([n({ type: Number })], ne.prototype, "selectedSDK");
De([n({ type: Array })], ne.prototype, "SDKManager");
De([n()], ne.prototype, "calendar");
const ve = (o) => new Intl.DateTimeFormat("en-US", { month: "long" }).format(o),
  dt = (o) => o.getFullYear().toString(),
  Nt = (o) => new Intl.DateTimeFormat("en-US", { weekday: "short" }).format(o),
  $e = (o) => o.getDate().toString(),
  Ie = (o) => {
    const e = o.getHours(),
      i = o.getMinutes().toString().padStart(2, "0"),
      s = e >= 12 ? "PM" : "AM";
    return `${e % 12 || 12}:${i} ${s}`;
  },
  xe = (o, e) => {
    let i = new Date(o.getTime() + e * 6e4);
    return {
      selectedDate: `${$e(o)} ${ve(o)} ${dt(o)}`,
      selectedDateWithoutYear: `${$e(o)} ${ve(o)}`,
      selectedTime: `${Ie(o)} - ${Ie(i)}`,
    };
  };
var Kt = Object.defineProperty,
  D = (o, e, i, s) => {
    for (var t = void 0, a = o.length - 1, r; a >= 0; a--)
      (r = o[a]) && (t = r(e, i, t) || t);
    return t && Kt(e, i, t), t;
  };
let _ = class extends m {
  constructor() {
    super(...arguments),
      (this.year = ""),
      (this.month = ""),
      (this.labels = []),
      (this.days = []),
      (this.timezone = null),
      (this.selectedDay = null),
      (this.selectedSlot = null),
      (this.renderCalendar = async () => {
        (this.days = []), (this.timezone = this.sesami.timezone);
        const e = new Date(this.sesami.now);
        (this.year = dt(e)),
          (this.month = ve(e)),
          (this.labels = this.sesami.data.labels.map((s) => Nt(new Date(s))));
        const i = [];
        await Promise.all(
          this.sesami.data.rows.map(async (s, t) => {
            i[t] = await Promise.all(
              s.map(async (a) => {
                let r = { availabilities: [], ...a };
                if (a.isCurrentMonth || !a.isPast)
                  try {
                    const c = await a.getAvailabilities();
                    c.length > 0 && (r.availabilities = c);
                  } catch (c) {
                    console.error(
                      `Error fetching availabilities for ${a.date}:`,
                      c
                    );
                  }
                return r;
              })
            );
          })
        ),
          (this.days = i);
      });
  }
  firstUpdated(e) {
    this.calendar && (this.selectedDay = this.calendar.day),
      this.renderCalendar();
  }
  updated(e) {
    e.has("sesami") && ((this.selectedDay = null), this.renderCalendar());
  }
  navigateMonth(e) {
    this.sesami[e]("month"), this.renderCalendar();
  }
  selectADay(e) {
    (this.selectedDay = e),
      this.dispatchEvent(
        new CustomEvent("setPageData", {
          bubbles: !0,
          composed: !0,
          detail: { pageData: { day: e }, page: "calendar" },
        })
      ),
      this.clickSlot(e.availabilities[0]);
  }
  clickSlot(e) {
    (this.selectedSlot = e),
      this.dispatchEvent(
        new CustomEvent("setPageData", {
          bubbles: !0,
          composed: !0,
          detail: { pageData: { slot: e }, page: "calendar" },
        })
      );
  }
};
D([n()], _.prototype, "sesami");
D([n()], _.prototype, "calendar");
D([p()], _.prototype, "year");
D([p()], _.prototype, "month");
D([p()], _.prototype, "labels");
D([p()], _.prototype, "days");
D([p()], _.prototype, "timezone");
D([p()], _.prototype, "selectedDay");
D([p()], _.prototype, "selectedSlot");
const y = [
  g`
    * {
      box-sizing: border-box;
      padding: 0;
      margin: 0;

      font-weight: 400;

      /* Font sizes multiplied by 1.5 */
      --fontSizeExtra: 2.6rem; /* 2rem * 1.5 */
      --fontSizeBig: 1.8rem; /* 1.5rem * 1.5 */
      --fontSizeMid: 1.4rem; /* 1.2rem * 1.5 */
      --fontSizeSmall: 1.2rem; /* 0.8rem * 1.5 */

      --secondaryColor: #fdfbf8;

      font-family: var(--sctype-spezia);
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      font-family: var(--font-heading-family);
    }

    @media (max-width: 2000px) {
      * {
        /* Font sizes multiplied by 1.5 */
        --fontSizeExtra: 2.4rem; /* 1.8rem * 1.5 */
        --fontSizeBig: 1.55rem; /* 1.3rem * 1.5 */
        --fontSizeMid: 1.1rem; /* 1rem * 1.5 */
        --fontSizeSmall: 1rem; /* Keeping as is for balance */
      }
    }

    @media (max-width: 1600px) {
      * {
        /* Font sizes multiplied by 1.5 */
        --fontSizeExtra: 2rem; /* 1.7rem * 1.5 */
        --fontSizeBig: 1.4rem; /* 1.2rem * 1.5 */
        --fontSizeMid: 1.1rem; /* 1rem * 1.5 */
        --fontSizeSmall: 1rem; /* Keeping as is for balance */
      }
    }

    @media (max-width: 600px) {
      * {
        /* Font sizes multiplied by 1.5 */
        --fontSizeExtra: 2.25rem; /* 1.5rem * 1.5 */
        --fontSizeBig: 1.35rem; /* 0.9rem * 1.5 */
        --fontSizeMid: 1.2rem; /* 0.7rem * 1.5 */
        --fontSizeSmall: 1rem; /* 0.6rem * 1.5 */
      }
    }

    .button {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 3rem;
      border-radius: 500px;
      text-transform: capitalize;
      cursor: pointer;
      font-size: var(--fontSizeSmall);
      text-transform: uppercase;
      letter-spacing: 2px;
      min-height: 40px;
      font-family: var(--sctype-spezia-extended);
      transition: all 250ms;
    }
    .button-fill {
      background-color: #2F3031;
      border: 1px solid #2F3031;
      color: #fff;

    }
    .button-fill:hover:not(.disable){
      background-color: #fff;
      color: black;
    }
    .button-outline {
      border: 1px solid black;
    }
    .button-outline:hover{
      background-color: black;
      color: #fff;
    }
  `,
];
var Lt = Object.defineProperty,
  de = (o, e, i, s) => {
    for (var t = void 0, a = o.length - 1, r; a >= 0; a--)
      (r = o[a]) && (t = r(e, i, t) || t);
    return t && Lt(e, i, t), t;
  };
let Q = class extends m {
  constructor() {
    super(...arguments),
      (this.month = ""),
      (this.year = ""),
      (this.timezone = "");
  }
};
de([n({ type: String })], Q.prototype, "month");
de([n({ type: String })], Q.prototype, "year");
de([n({ type: String })], Q.prototype, "timezone");
de([n()], Q.prototype, "onNavigate");
const Be =
  "data:image/svg+xml,%3csvg%20width='16'%20height='9'%20viewBox='0%200%2016%209'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M15.1422%201.07107L8.07108%208.14214L1.00002%201.07107'%20stroke='black'/%3e%3c/svg%3e";
var zt = Object.defineProperty,
  jt = Object.getOwnPropertyDescriptor,
  Ut = (o, e, i, s) => {
    for (
      var t = s > 1 ? void 0 : s ? jt(e, i) : e, a = o.length - 1, r;
      a >= 0;
      a--
    )
      (r = o[a]) && (t = (s ? r(e, i, t) : r(t)) || t);
    return s && t && zt(e, i, t), t;
  };
let He = class extends Q {
  render() {
    return l`
      <div class="header">
        <div class="date">
          <span class="month">${this.month} ${this.year.substring(2)}</span>
        </div>
        <div class="controller">
          <span
            class="arrow left"
            title="previous"
            @click=${() => this.onNavigate("previous")}
          >
            <img src=${Be} alt="left arrow" />
          </span>
          <span
            class="arrow right"
            title="next"
            @click=${() => this.onNavigate("next")}
          >
            <img src=${Be} alt="right arrow" />
          </span>
        </div>
      </div>
    `;
  }
  static get styles() {
    return [
      y,
      g`
        .header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-top: 1px solid #000000;
          border-bottom: 1px solid #000000;
          padding: 0.5rem 0;
        }
        .month {
          font-size: var(--fontSizeSmall);
          text-transform: uppercase;
          letter-spacing: 2px;
          font-weight: 300;
        }
        .controller {
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .arrow {
          cursor: pointer;
          height: 2.5rem;
          width: 2.5rem;
          display: flex;
          justify-content: center;
          align-items: center;
          transition: background-color 0.3s;
        }
        .arrow:nth-child(1) {
          margin-right: 3rem;
        }

        .arrow img {
          width: 75%;
        }
        .left img {
          transform: rotate(90deg);
        }
        .right img {
          transform: rotate(-90deg);
        }
        .button:hover {
          color: rgba(0, 0, 0, 0.5);
        }

        @media (max-width: 600px) {
          .header {
            padding: 1rem 0;
          }
          .arrow:nth-child(1) {
            margin-right: 2rem;
          }
        }
      `,
    ];
  }
};
He = Ut([$("calendar-component-header")], He);
var It = Object.defineProperty,
  le = (o, e, i, s) => {
    for (var t = void 0, a = o.length - 1, r; a >= 0; a--)
      (r = o[a]) && (t = r(e, i, t) || t);
    return t && It(e, i, t), t;
  };
let X = class extends m {
  constructor() {
    super(...arguments),
      (this.labels = []),
      (this.days = []),
      (this.selectedDay = null);
  }
};
le([n({ type: Array })], X.prototype, "labels");
le([n({ type: Array })], X.prototype, "days");
le([n()], X.prototype, "onSelectDay");
le([n({ type: Object })], X.prototype, "selectedDay");
var Bt = Object.defineProperty,
  Ht = Object.getOwnPropertyDescriptor,
  Rt = (o, e, i, s) => {
    for (
      var t = s > 1 ? void 0 : s ? Ht(e, i) : e, a = o.length - 1, r;
      a >= 0;
      a--
    )
      (r = o[a]) && (t = (s ? r(e, i, t) : r(t)) || t);
    return s && t && Bt(e, i, t), t;
  };
let Re = class extends X {
  render() {
    return l`
      <div class="labels">
        ${this.labels.map((e) => l`<span class="label">${e}</span>`)}
      </div>

      ${
        this.days.length > 0
          ? this.days.map(
              (e) => l`
              <div class="days">
                ${e.map((i) => {
                  var s;
                  return l`
                    <span
                      class=${[
                        ((s = this.selectedDay) == null ? void 0 : s.date) ===
                        i.date
                          ? "day selected"
                          : "",
                        i.availabilities.length > 0
                          ? "day active"
                          : "day empty",
                        i.isCurrentMonth ? "" : "nextMonth",
                      ]
                        .join(" ")
                        .trim()}
                      @click=${() => {
                        i.availabilities.length > 0 && this.onSelectDay(i);
                      }}
                      >${$e(new Date(i.date))}</span
                    >
                  `;
                })}
              </div>
            `
            )
          : new Array(5).fill(null).map(
              (e, i) => l`
              <div class="days">
                <span class="day empty">${i + 1}</span>
              </div>
            `
            )
      }
    `;
  }
  static get styles() {
    return [
      y,
      g`
        .labels {
          display: grid;
          grid-template-columns: repeat(7, 1fr); /* 7 columns for 7 days */
          padding-bottom: 0.5rem;
        }

        .label {
          font-size: var(--fontSizeMid);
          letter-spacing: 0.1rem;
          font-family: var(--sctype-spezia-extended);
          color: #333;
          text-align: center;
          text-transform: uppercase;
        }

        .days {
          display: grid;
          grid-template-columns: repeat(
            7,
            1fr
          ); /* Same grid structure as labels */
        }

        .day {
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          aspect-ratio: 8/6;
          outline: 1px solid #868686;
          background-color: #ffffff;
          overflow: hidden;
          font-size: var(--fontSizeMid);
          background-color: var(--secondaryColor);
          color: #000;
        }
        .nextMonth {
          color: #b3b3b3;
        }
        .active {
          cursor: pointer;
          transition: background-color 0.3s;
        }
        .selected {
          background-color: #141414;
          color: #fff;
        }
        .active:hover {
          background-color: #141414;
          color: #fff;
        }
        .empty {
          color: #868686;
          cursor: default;
        }
        .empty::after {
          content: "";
          position: absolute;
          top: 0;
          left: 100%;
          width: 1px; /* Line thickness */
          height: 250%; /* Line length, adjust if necessary */
          background-color: #b3b3b3;
          transform: rotate(53.6deg);
          transform-origin: 0 0; /* Ensures rotation starts from top-left */
        }

        @media (max-width: 600px) {
          .labels {
            padding-bottom: 0.5rem;
          }
          .day {
            aspect-ratio: 1;
          }
          .empty::after {
            transform: rotate(46deg);
          }
        }
      `,
    ];
  }
};
Re = Rt([$("calendar-component-body")], Re);
var Ft = Object.defineProperty,
  kt = Object.getOwnPropertyDescriptor,
  Gt = (o, e, i, s) => {
    for (
      var t = s > 1 ? void 0 : s ? kt(e, i) : e, a = o.length - 1, r;
      a >= 0;
      a--
    )
      (r = o[a]) && (t = (s ? r(e, i, t) : r(t)) || t);
    return s && t && Ft(e, i, t), t;
  };
let Fe = class extends _ {
  render() {
    var o, e;
    return l`
      <div class="calendar">
        <calendar-component-header
          .month=${this.month}
          .year=${this.year}
          .timezone=${this.timezone}
          .onNavigate=${this.navigateMonth.bind(this)}
        ></calendar-component-header>

        <div class=${this.days.length === 0 ? "loader" : "loader hidden"}>
          <loading-component></loading-component>
        </div>

        <calendar-component-body
          class=${this.days.length > 0 ? "" : "hidden"}
          .labels=${this.labels}
          .days=${this.days}
          .selectedDay=${this.selectedDay}
          .onSelectDay=${this.selectADay.bind(this)}
        ></calendar-component-body>

        <dropdown-component
          title="slots"
          class=${this.selectedDay ? "dropDown " : "dropDown hidden"}
          .options=${(o = this.selectedDay) == null ? void 0 : o.availabilities}
          .value=${
            (e = this.selectedDay) == null ? void 0 : e.availabilities[0]
          }
          .onSelect=${this.clickSlot.bind(this)}
        ></dropdown-component>
      </div>
    `;
  }
  static get styles() {
    return [
      y,
      g`
        .calendar {
          width: 100%;
          height: 100%;
          max-width: 1600px;
          display: flex;
          flex-direction: column;
          gap: 1rem;
        }
        calendar-component-header {
          height: 10%;
        }
        calendar-component-body {
          padding: 2rem 2.5rem;
        }
        dropdown-component {
          padding: 0 2.5rem;
        }

        .loader {
          position: absolute;
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100%;
          width: 100%;
          pointer-events: none;
          left: 0;
          top: 0;
          z-index: 1;
        }
        .dropDown {
          opacity: 1;
          transition: all 0.2s linear;
        }
        .hidden {
          opacity: 0;
        }
        @media (max-width: 600px) {
          .calendar {
            gap: 2rem;
          }
          calendar-component-header {
            height: unset;
          }
          calendar-component-body {
            padding: 0;
            margin-top: 1.5rem;
            margin-bottom: 1rem;
          }
          dropdown-component {
            padding: 0;
          }
        }
      `,
    ];
  }
};
Fe = Gt([$("calendar-component")], Fe);
var Vt = Object.defineProperty,
  Pe = (o, e, i, s) => {
    for (var t = void 0, a = o.length - 1, r; a >= 0; a--)
      (r = o[a]) && (t = r(e, i, t) || t);
    return t && Vt(e, i, t), t;
  };
let ce = class extends m {
  constructor() {
    super(...arguments), (this.options = []);
  }
};
Pe([n()], ce.prototype, "options");
Pe([n()], ce.prototype, "value");
Pe([n()], ce.prototype, "onSelect");
var Wt = Object.defineProperty,
  Yt = Object.getOwnPropertyDescriptor,
  qt = (o, e, i, s) => {
    for (
      var t = s > 1 ? void 0 : s ? Yt(e, i) : e, a = o.length - 1, r;
      a >= 0;
      a--
    )
      (r = o[a]) && (t = (s ? r(e, i, t) : r(t)) || t);
    return s && t && Wt(e, i, t), t;
  };
let ke = class extends ce {
  render() {
    return l`
      <select
        @change=${(o) => {
          var t;
          const i = o.target.value,
            s =
              (t = this.options) == null
                ? void 0
                : t.find((a) => a.startTime === i);
          s && this.onSelect(s);
        }}
      >
        ${
          this.options
            ? this.options.map((o) => {
                var s;
                let e = o.startTime.replace(" ", "T"),
                  { selectedTime: i } = xe(new Date(e), o.duration);
                return l`
                <option
                  value=${o.startTime}
                  ?selected=${
                    ((s = this.value) == null ? void 0 : s.startTime) ===
                    o.startTime
                  }
                >
                  ${i} / ${o.remainingSlots}
                  ${o.remainingSlots === 1 ? "space" : "spaces"}
                </option>
              `;
              })
            : ""
        }
      </select>
    `;
  }
  static get styles() {
    return [
      y,
      g`
        select {
          width: 100%;
          background-color: transparent;
          text-overflow: ellipsis;
          border: none;
          transition: all 0.2s ease-in-out;
          cursor: pointer;
          font-size: var(--fontSizeBig);
          border: none;
          border-bottom: 1px solid black;
          outline: none;
        }
        select:active {
          background-color: #cccccc;
        }
      `,
    ];
  }
};
ke = qt([$("dropdown-component")], ke);
var Zt = Object.defineProperty,
  Ae = (o, e, i, s) => {
    for (var t = void 0, a = o.length - 1, r; a >= 0; a--)
      (r = o[a]) && (t = r(e, i, t) || t);
    return t && Zt(e, i, t), t;
  };
let pe = class extends m {};
Ae([n()], pe.prototype, "name");
Ae([n()], pe.prototype, "error");
Ae([n()], pe.prototype, "type");
var Jt = Object.defineProperty,
  Qt = Object.getOwnPropertyDescriptor,
  Xt = (o, e, i, s) => {
    for (
      var t = s > 1 ? void 0 : s ? Qt(e, i) : e, a = o.length - 1, r;
      a >= 0;
      a--
    )
      (r = o[a]) && (t = (s ? r(e, i, t) : r(t)) || t);
    return s && t && Jt(e, i, t), t;
  };
let Ge = class extends pe {
  render() {
    return l`
      <div class="wrapper ${this.type === "checkbox" ? "checkbox" : ""} ">
        ${this.name && l`<a class="name">${this.name}</a>`}
        <slot></slot>

        <div class="wrapper-error">
          <p class="message">${this.error ? this.error : ""}</p>
        </div>
      </div>
    `;
  }
  static get styles() {
    return [
      y,
      g`
        .wrapper {
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          .name {
            text-transform: uppercase;
            font-size: var(--fontSizeMid);
            font-family: var(--sctype-spezia-extended);
            color: #000;
          }
        }
        .checkbox {
          flex-direction: row-reverse;
          justify-content: flex-end;
        }
        .wrapper-error {
          position: relative;
          display: flex;
          align-items: center;
          width: 100%;
          .message {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: fit-content;
            color: red;
            font-size: var(--fontSizeSmall);
          }
        }
      `,
    ];
  }
};
Ge = Xt([$("field-wrapper-component")], Ge);
var ei = Object.defineProperty,
  x = (o, e, i, s) => {
    for (var t = void 0, a = o.length - 1, r; a >= 0; a--)
      (r = o[a]) && (t = r(e, i, t) || t);
    return t && ei(e, i, t), t;
  };
let w = class extends m {
  constructor() {
    super(...arguments),
      (this.type = "text"),
      (this.name = ""),
      (this.value = ""),
      (this.placeholder = ""),
      (this.maxLength = 100),
      (this.isEnable = !0),
      (this.showErrorText = !0);
  }
  onChange(e, i) {
    const s = e.target;
    if (s && this.validate) {
      let { valid: t, message: a, type: r } = this.validate(s.value);
      !t && r === "all"
        ? (this.error = a)
        : !t && i === r
        ? (this.error = a)
        : (this.error = void 0);
    }
    this.dispatchEvent(
      new CustomEvent("input--changed", {
        bubbles: !0,
        composed: !0,
        detail: { event: e },
      })
    );
  }
  onConfirm() {
    this.dispatchEvent(
      new CustomEvent("input--confirm", {
        bubbles: !0,
        composed: !0,
        detail: {},
      })
    );
  }
};
x([n()], w.prototype, "validate");
x([n()], w.prototype, "type");
x([n()], w.prototype, "name");
x([n()], w.prototype, "value");
x([n()], w.prototype, "placeholder");
x([n({ type: Number })], w.prototype, "maxLength");
x([n({ type: Boolean })], w.prototype, "isEnable");
x([n({ type: Boolean })], w.prototype, "showErrorText");
x([p()], w.prototype, "error");
var ti = Object.defineProperty,
  ii = Object.getOwnPropertyDescriptor,
  oi = (o, e, i, s) => {
    for (
      var t = s > 1 ? void 0 : s ? ii(e, i) : e, a = o.length - 1, r;
      a >= 0;
      a--
    )
      (r = o[a]) && (t = (s ? r(e, i, t) : r(t)) || t);
    return s && t && ti(e, i, t), t;
  };
let Ve = class extends w {
  render() {
    return l`
      <field-wrapper-component
        .name=${this.name}
        .error=${this.showErrorText ? this.error : void 0}
        .type=${this.type}
      >
        <input
          type=${this.type}
          .value=${this.value}
          class="input ${this.type === "checkbox" ? "checkbox" : ""} ${
      this.error ? "error" : ""
    }"
          title=${this.name}
          placeholder=${this.placeholder}
          maxlength=${this.maxLength}
          ?disabled=${!this.isEnable}
          @input=${(o) => this.onChange(o, "input")}
          @blur=${(o) => this.onChange(o, "blur")}
          @keyup=${(o) => {
            o.key === "Enter" && this.onConfirm();
          }}
        />
      </field-wrapper-component>
    `;
  }
  static get styles() {
    return [
      y,
      g`
        .input {
          width: 100%;
          padding-top: 0.5rem;
          padding-bottom: 0.25rem;
          font-size: var(--fontSizeBig);
          border: none;
          border-bottom: solid 1px #000;
          outline: none;
        }
        .checkbox {
          aspect-ratio: 1;
          accent-color: #333333;
        }
        .error {
          border-color: red;
          outline-color: red;
        }
      `,
    ];
  }
};
Ve = oi([$("input-field-component")], Ve);
var si = Object.defineProperty,
  ee = (o, e, i, s) => {
    for (var t = void 0, a = o.length - 1, r; a >= 0; a--)
      (r = o[a]) && (t = r(e, i, t) || t);
    return t && si(e, i, t), t;
  };
let F = class extends m {
  constructor() {
    super(...arguments),
      (this.selectSDK = () => {}),
      (this.close = () => {}),
      (this.currentIndex = 0),
      (this.selectedSDK = 0);
  }
};
ee([n({ type: Object })], F.prototype, "data");
ee([n()], F.prototype, "selectSDK");
ee([n()], F.prototype, "close");
ee([n()], F.prototype, "currentIndex");
ee([n()], F.prototype, "selectedSDK");
const ai =
  "data:image/svg+xml,%3csvg%20width='25'%20height='25'%20viewBox='0%200%2025%2025'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M18.5104%206.48959L6.48962%2018.5104'%20stroke='black'%20stroke-width='1.5'%20stroke-linecap='square'/%3e%3cpath%20d='M18.5104%2018.5104L6.48962%206.48959'%20stroke='black'%20stroke-width='1.5'%20stroke-linecap='square'/%3e%3c/svg%3e";
var ri = Object.defineProperty,
  ni = Object.getOwnPropertyDescriptor,
  di = (o, e, i, s) => {
    for (
      var t = s > 1 ? void 0 : s ? ni(e, i) : e, a = o.length - 1, r;
      a >= 0;
      a--
    )
      (r = o[a]) && (t = (s ? r(e, i, t) : r(t)) || t);
    return s && t && ri(e, i, t), t;
  };
let We = class extends F {
  render() {
    return l`
      <div class="header">
        <div class="tabs">
          ${
            this.currentIndex === 0
              ? this.data.services.map(
                  (o, e) => l`
                  <div
                    class=${
                      o.tabName === this.data.services[this.selectedSDK].tabName
                        ? "tab active"
                        : "tab"
                    }
                    @click=${() => this.selectSDK(e)}
                  >
                    ${o.tabName}
                  </div>
                `
                )
              : l`<div class="tab active">
                ${this.data.services[this.selectedSDK].tabName}
              </div>`
          }
        </div>
        <div @click=${() => this.close()} class="close">
          <img src=${ai} alt="close" />
        </div>
      </div>
    `;
  }
  static get styles() {
    return [
      y,
      g`
        .header {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .tabs {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .tab {
          cursor: pointer;
          margin-right: 3rem;
          transition: all 0.2s linear;
          font-size: var(--fontSizeBig);
          opacity: 0.7;
          letter-spacing: 1.5px;
          text-transform: uppercase;
          font-family: var(--sctype-spezia-extended);
        }
        .active {
          opacity: 1;
          font-weight: 600;
          border-bottom: 2px solid black;
        }
        .close {
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          aspect-ratio: 1;
        }
        .close img {
          width: 100%;
        }

        @media (max-width: 600px) {
          .header {
            flex-direction: column-reverse;
            align-items: flex-end;
            flex: 1;
          }
          .tabs {
            width: 100%;
          }
          .tab {
            margin-right: 0;
          }
        }
      `,
    ];
  }
};
We = di([$("header-component")], We);
var li = Object.defineProperty,
  k = (o, e, i, s) => {
    for (var t = void 0, a = o.length - 1, r; a >= 0; a--)
      (r = o[a]) && (t = r(e, i, t) || t);
    return t && li(e, i, t), t;
  };
let U = class extends m {
  constructor() {
    super(...arguments),
      (this.navigateTo = () => {}),
      (this.currentIndex = 0),
      (this.close = () => {}),
      (this.confirm = () => {});
  }
};
k([n()], U.prototype, "navigateTo");
k([n()], U.prototype, "currentIndex");
k([n()], U.prototype, "calendar");
k([n()], U.prototype, "form");
k([n()], U.prototype, "close");
k([n()], U.prototype, "confirm");
var ci = Object.defineProperty,
  pi = Object.getOwnPropertyDescriptor,
  hi = (o, e, i, s) => {
    for (
      var t = s > 1 ? void 0 : s ? pi(e, i) : e, a = o.length - 1, r;
      a >= 0;
      a--
    )
      (r = o[a]) && (t = (s ? r(e, i, t) : r(t)) || t);
    return s && t && ci(e, i, t), t;
  };
let Ye = class extends U {
  render() {
    var o, e;
    return l`
      <div class="buttons">
        ${
          this.currentIndex === 0
            ? l`<span
              @click=${() => {
                var i;
                return (i = this.calendar) != null && i.slot
                  ? this.navigateTo({ direction: 1 })
                  : "";
              }}
              class=${
                (o = this.calendar) != null && o.slot
                  ? "button button-fill"
                  : "button button-fill disable"
              }
            >
              next
            </span>`
            : this.currentIndex === 1
            ? l`<span
                @click=${() => {
                  var i;
                  (i = this.form) != null && i.valid && this.confirm();
                }}
                class=${
                  (e = this.form) != null && e.valid
                    ? "button button-fill"
                    : "button button-fill disable"
                }
              >
                confirm </span
              ><span
                @click=${() => this.navigateTo({ direction: -1 })}
                class="button button-outline"
              >
                back
              </span>`
            : l`<span @click=${() => this.close()} class="button button-fill">
              close
            </span>`
        }
      </div>
    `;
  }
  static get styles() {
    return [
      y,
      g`
        .buttons {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-between;
          gap: 2.5rem;

          .button {
            width: 100%;
            font-size: var(--fontSizeMid);
            transition: all 0.2s linear;
          }

          .disable {
            opacity: 0.7;
            cursor: not-allowed;
          }
        }
      `,
    ];
  }
};
Ye = hi([$("navigation-component")], Ye);
let ui = class extends m {};
var mi = Object.defineProperty,
  fi = Object.getOwnPropertyDescriptor,
  gi = (o, e, i, s) => {
    for (
      var t = s > 1 ? void 0 : s ? fi(e, i) : e, a = o.length - 1, r;
      a >= 0;
      a--
    )
      (r = o[a]) && (t = (s ? r(e, i, t) : r(t)) || t);
    return s && t && mi(e, i, t), t;
  };
let qe = class extends ui {
  render() {
    return l` <div class="loader"></div> `;
  }
  static get styles() {
    return [
      y,
      g`
        :host {
          display: flex;
          justify-content: center;
          align-items: center;
        }
        /* HTML: <div class="loader"></div> */
        /* HTML: <div class="loader"></div> */
        .loader {
          width: 50px;
          aspect-ratio: 1;
          border-radius: 50%;
          background: radial-gradient(farthest-side, #000000 94%, #0000) top/8px
              8px no-repeat,
            conic-gradient(#0000 30%, #000000);
          -webkit-mask: radial-gradient(
            farthest-side,
            #0000 calc(100% - 8px),
            #000 0
          );
          animation: l13 1s infinite linear;
        }
        @keyframes l13 {
          100% {
            transform: rotate(1turn);
          }
        }
      `,
    ];
  }
};
qe = gi([$("loading-component")], qe);
var vi = Object.defineProperty,
  he = (o, e, i, s) => {
    for (var t = void 0, a = o.length - 1, r; a >= 0; a--)
      (r = o[a]) && (t = r(e, i, t) || t);
    return t && vi(e, i, t), t;
  };
let te = class extends m {
  constructor() {
    super(...arguments),
      (this.name = ""),
      (this.value = 1),
      (this.isEnable = !0),
      (this.maxCount = 3);
  }
  increment() {
    this.value < this.maxCount && ((this.value += 1), this.onChange());
  }
  decrement() {
    this.value > 1 && ((this.value -= 1), this.onChange());
  }
  onChange() {
    const e = new CustomEvent("input--changed", {
      bubbles: !0,
      composed: !0,
      detail: { event: { target: { value: this.value } } },
    });
    this.dispatchEvent(e);
  }
};
he([n()], te.prototype, "name");
he([n({ type: Number })], te.prototype, "value");
he([n({ type: Boolean })], te.prototype, "isEnable");
he([n({ type: Number })], te.prototype, "maxCount");
const $i =
    "data:image/svg+xml,%3csvg%20width='19'%20height='19'%20viewBox='0%200%2019%2019'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M9.5%201L9.5%2018'%20stroke='black'%20stroke-width='2'%20stroke-linecap='square'/%3e%3cpath%20d='M18%209.5L1%209.5'%20stroke='black'%20stroke-width='2'%20stroke-linecap='square'/%3e%3c/svg%3e",
  yi =
    "data:image/svg+xml,%3csvg%20width='16'%20height='16'%20viewBox='0%200%2016%2016'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M12%208L4%208'%20stroke='black'%20stroke-width='2'%20stroke-linecap='square'/%3e%3c/svg%3e";
var Ci = Object.defineProperty,
  bi = Object.getOwnPropertyDescriptor,
  _i = (o, e, i, s) => {
    for (
      var t = s > 1 ? void 0 : s ? bi(e, i) : e, a = o.length - 1, r;
      a >= 0;
      a--
    )
      (r = o[a]) && (t = (s ? r(e, i, t) : r(t)) || t);
    return s && t && Ci(e, i, t), t;
  };
let Ze = class extends te {
  render() {
    return l`
      <field-wrapper-component .name=${this.name} type="text">
        <div class="counter">
          <button
            class="button"
            @click=${this.decrement}
            ?disabled=${this.value <= 1}
          >
            <img src=${yi} alt="minus" />
          </button>
          <div class="count">${this.value}</div>
          <button
            class="button"
            @click=${this.increment}
            ?disabled=${this.value >= this.maxCount}
          >
            <img src=${$i} alt="plus" />
          </button>
        </div>
        <div class="max-info">Max available: ${this.maxCount}</div>
      </field-wrapper-component>
    `;
  }
  static get styles() {
    return [
      y,
      g`
        :host {
          display: inline-block;
          text-align: center;
        }
        .counter {
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 10px 0;
        }
        .button {
          width: 3rem;
          height: 3rem;
          background-color: #000;
          color: #fff;
          border-radius: 5px;
          border: none;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 !important;
          min-height: unset !important;
        }
        .button img {
          width: 60%;
          filter: invert(100%);
        }
        .button:disabled {
          background-color: #ddd;
          cursor: not-allowed;
        }
        .count {
          margin: 0 15px;
          font-size: var(--fontSizeBig);
        }
        .max-info {
          color: #666;
          font-size: var(--fontSizeSmall);
        }
        @media (max-width: 1600px) {
          .button {
            width: 2.5rem;
            height: 2.5rem;
          }
          .count {
            font-size: var(--fontSizeBig);
          }
        }
        @media (max-width: 600px) {
          .count {
            font-size: var(--fontSizeBig);
          }
        }
      `,
    ];
  }
};
Ze = _i([$("counter-component")], Ze);
var wi = Object.defineProperty,
  b = (o, e, i, s) => {
    for (var t = void 0, a = o.length - 1, r; a >= 0; a--)
      (r = o[a]) && (t = r(e, i, t) || t);
    return t && wi(e, i, t), t;
  };
let C = class extends m {
  constructor() {
    super(...arguments),
      (this.name = ""),
      (this.value = ""),
      (this.placeholder = ""),
      (this.maxLength = 100),
      (this.isEnable = !0),
      (this.showErrorText = !0),
      (this.phoneNumber = ""),
      (this.selectedCode = "US"),
      (this.selectedDialCode = "+1"),
      (this.countryCodes = [
        { dialCode: "+93", code: "AF" },
        { dialCode: "+358", code: "AX" },
        { dialCode: "+355", code: "AL" },
        { dialCode: "+213", code: "DZ" },
        { dialCode: "+1684", code: "AS" },
        { dialCode: "+376", code: "AD" },
        { dialCode: "+244", code: "AO" },
        { dialCode: "+1264", code: "AI" },
        { dialCode: "+672", code: "AQ" },
        { dialCode: "+1268", code: "AG" },
        { dialCode: "+54", code: "AR" },
        { dialCode: "+374", code: "AM" },
        { dialCode: "+297", code: "AW" },
        { dialCode: "+61", code: "AU" },
        { dialCode: "+43", code: "AT" },
        { dialCode: "+994", code: "AZ" },
        { dialCode: "+1242", code: "BS" },
        { dialCode: "+973", code: "BH" },
        { dialCode: "+880", code: "BD" },
        { dialCode: "+1246", code: "BB" },
        { dialCode: "+375", code: "BY" },
        { dialCode: "+32", code: "BE" },
        { dialCode: "+501", code: "BZ" },
        { dialCode: "+229", code: "BJ" },
        { dialCode: "+1441", code: "BM" },
        { dialCode: "+975", code: "BT" },
        { dialCode: "+591", code: "BO" },
        { dialCode: "+387", code: "BA" },
        { dialCode: "+267", code: "BW" },
        { dialCode: "+55", code: "BR" },
        { dialCode: "+246", code: "IO" },
        { dialCode: "+673", code: "BN" },
        { dialCode: "+359", code: "BG" },
        { dialCode: "+226", code: "BF" },
        { dialCode: "+257", code: "BI" },
        { dialCode: "+855", code: "KH" },
        { dialCode: "+237", code: "CM" },
        { dialCode: "+1", code: "CA" },
        { dialCode: "+238", code: "CV" },
        { dialCode: "+ 345", code: "KY" },
        { dialCode: "+236", code: "CF" },
        { dialCode: "+235", code: "TD" },
        { dialCode: "+56", code: "CL" },
        { dialCode: "+86", code: "CN" },
        { dialCode: "+61", code: "CX" },
        { dialCode: "+61", code: "CC" },
        { dialCode: "+57", code: "CO" },
        { dialCode: "+269", code: "KM" },
        { dialCode: "+242", code: "CG" },
        { dialCode: "+243", code: "CD" },
        { dialCode: "+682", code: "CK" },
        { dialCode: "+506", code: "CR" },
        { dialCode: "+225", code: "CI" },
        { dialCode: "+385", code: "HR" },
        { dialCode: "+53", code: "CU" },
        { dialCode: "+357", code: "CY" },
        { dialCode: "+420", code: "CZ" },
        { dialCode: "+45", code: "DK" },
        { dialCode: "+253", code: "DJ" },
        { dialCode: "+1767", code: "DM" },
        { dialCode: "+1849", code: "DO" },
        { dialCode: "+593", code: "EC" },
        { dialCode: "+20", code: "EG" },
        { dialCode: "+503", code: "SV" },
        { dialCode: "+240", code: "GQ" },
        { dialCode: "+291", code: "ER" },
        { dialCode: "+372", code: "EE" },
        { dialCode: "+251", code: "ET" },
        { dialCode: "+500", code: "FK" },
        { dialCode: "+298", code: "FO" },
        { dialCode: "+679", code: "FJ" },
        { dialCode: "+358", code: "FI" },
        { dialCode: "+33", code: "FR" },
        { dialCode: "+594", code: "GF" },
        { dialCode: "+689", code: "PF" },
        { dialCode: "+241", code: "GA" },
        { dialCode: "+220", code: "GM" },
        { dialCode: "+995", code: "GE" },
        { dialCode: "+49", code: "DE" },
        { dialCode: "+233", code: "GH" },
        { dialCode: "+350", code: "GI" },
        { dialCode: "+30", code: "GR" },
        { dialCode: "+299", code: "GL" },
        { dialCode: "+1473", code: "GD" },
        { dialCode: "+590", code: "GP" },
        { dialCode: "+1671", code: "GU" },
        { dialCode: "+502", code: "GT" },
        { dialCode: "+44", code: "GG" },
        { dialCode: "+224", code: "GN" },
        { dialCode: "+245", code: "GW" },
        { dialCode: "+595", code: "GY" },
        { dialCode: "+509", code: "HT" },
        { dialCode: "+379", code: "VA" },
        { dialCode: "+504", code: "HN" },
        { dialCode: "+852", code: "HK" },
        { dialCode: "+36", code: "HU" },
        { dialCode: "+354", code: "IS" },
        { dialCode: "+91", code: "IN" },
        { dialCode: "+62", code: "ID" },
        { dialCode: "+98", code: "IR" },
        { dialCode: "+964", code: "IQ" },
        { dialCode: "+353", code: "IE" },
        { dialCode: "+44", code: "IM" },
        { dialCode: "+972", code: "IL" },
        { dialCode: "+39", code: "IT" },
        { dialCode: "+1876", code: "JM" },
        { dialCode: "+81", code: "JP" },
        { dialCode: "+44", code: "JE" },
        { dialCode: "+962", code: "JO" },
        { dialCode: "+77", code: "KZ" },
        { dialCode: "+254", code: "KE" },
        { dialCode: "+686", code: "KI" },
        { dialCode: "+850", code: "KP" },
        { dialCode: "+82", code: "KR" },
        { dialCode: "+965", code: "KW" },
        { dialCode: "+996", code: "KG" },
        { dialCode: "+856", code: "LA" },
        { dialCode: "+371", code: "LV" },
        { dialCode: "+961", code: "LB" },
        { dialCode: "+266", code: "LS" },
        { dialCode: "+231", code: "LR" },
        { dialCode: "+218", code: "LY" },
        { dialCode: "+423", code: "LI" },
        { dialCode: "+370", code: "LT" },
        { dialCode: "+352", code: "LU" },
        { dialCode: "+853", code: "MO" },
        { dialCode: "+389", code: "MK" },
        { dialCode: "+261", code: "MG" },
        { dialCode: "+265", code: "MW" },
        { dialCode: "+60", code: "MY" },
        { dialCode: "+960", code: "MV" },
        { dialCode: "+223", code: "ML" },
        { dialCode: "+356", code: "MT" },
        { dialCode: "+692", code: "MH" },
        { dialCode: "+596", code: "MQ" },
        { dialCode: "+222", code: "MR" },
        { dialCode: "+230", code: "MU" },
        { dialCode: "+262", code: "YT" },
        { dialCode: "+52", code: "MX" },
        { dialCode: "+691", code: "FM" },
        { dialCode: "+373", code: "MD" },
        { dialCode: "+377", code: "MC" },
        { dialCode: "+976", code: "MN" },
        { dialCode: "+382", code: "ME" },
        { dialCode: "+1664", code: "MS" },
        { dialCode: "+212", code: "MA" },
        { dialCode: "+258", code: "MZ" },
        { dialCode: "+95", code: "MM" },
        { dialCode: "+264", code: "NA" },
        { dialCode: "+674", code: "NR" },
        { dialCode: "+977", code: "NP" },
        { dialCode: "+31", code: "NL" },
        { dialCode: "+599", code: "AN" },
        { dialCode: "+687", code: "NC" },
        { dialCode: "+64", code: "NZ" },
        { dialCode: "+505", code: "NI" },
        { dialCode: "+227", code: "NE" },
        { dialCode: "+234", code: "NG" },
        { dialCode: "+683", code: "NU" },
        { dialCode: "+672", code: "NF" },
        { dialCode: "+1670", code: "MP" },
        { dialCode: "+47", code: "NO" },
        { dialCode: "+968", code: "OM" },
        { dialCode: "+92", code: "PK" },
        { dialCode: "+680", code: "PW" },
        { dialCode: "+970", code: "PS" },
        { dialCode: "+507", code: "PA" },
        { dialCode: "+675", code: "PG" },
        { dialCode: "+595", code: "PY" },
        { dialCode: "+51", code: "PE" },
        { dialCode: "+63", code: "PH" },
        { dialCode: "+872", code: "PN" },
        { dialCode: "+48", code: "PL" },
        { dialCode: "+351", code: "PT" },
        { dialCode: "+1939", code: "PR" },
        { dialCode: "+974", code: "QA" },
        { dialCode: "+40", code: "RO" },
        { dialCode: "+7", code: "RU" },
        { dialCode: "+250", code: "RW" },
        { dialCode: "+262", code: "RE" },
        { dialCode: "+590", code: "BL" },
        { dialCode: "+290", code: "SH" },
        { dialCode: "+1869", code: "KN" },
        { dialCode: "+1758", code: "LC" },
        { dialCode: "+590", code: "MF" },
        { dialCode: "+508", code: "PM" },
        { dialCode: "+1784", code: "VC" },
        { dialCode: "+685", code: "WS" },
        { dialCode: "+378", code: "SM" },
        { dialCode: "+239", code: "ST" },
        { dialCode: "+966", code: "SA" },
        { dialCode: "+221", code: "SN" },
        { dialCode: "+381", code: "RS" },
        { dialCode: "+248", code: "SC" },
        { dialCode: "+232", code: "SL" },
        { dialCode: "+65", code: "SG" },
        { dialCode: "+421", code: "SK" },
        { dialCode: "+386", code: "SI" },
        { dialCode: "+677", code: "SB" },
        { dialCode: "+252", code: "SO" },
        { dialCode: "+27", code: "ZA" },
        { dialCode: "+211", code: "SS" },
        { dialCode: "+500", code: "GS" },
        { dialCode: "+34", code: "ES" },
        { dialCode: "+94", code: "LK" },
        { dialCode: "+249", code: "SD" },
        { dialCode: "+597", code: "SR" },
        { dialCode: "+47", code: "SJ" },
        { dialCode: "+268", code: "SZ" },
        { dialCode: "+46", code: "SE" },
        { dialCode: "+41", code: "CH" },
        { dialCode: "+963", code: "SY" },
        { dialCode: "+886", code: "TW" },
        { dialCode: "+992", code: "TJ" },
        { dialCode: "+255", code: "TZ" },
        { dialCode: "+66", code: "TH" },
        { dialCode: "+670", code: "TL" },
        { dialCode: "+228", code: "TG" },
        { dialCode: "+690", code: "TK" },
        { dialCode: "+676", code: "TO" },
        { dialCode: "+1868", code: "TT" },
        { dialCode: "+216", code: "TN" },
        { dialCode: "+90", code: "TR" },
        { dialCode: "+993", code: "TM" },
        { dialCode: "+1649", code: "TC" },
        { dialCode: "+688", code: "TV" },
        { dialCode: "+256", code: "UG" },
        { dialCode: "+380", code: "UA" },
        { dialCode: "+971", code: "AE" },
        { dialCode: "+44", code: "GB" },
        { dialCode: "+1", code: "US" },
        { dialCode: "+598", code: "UY" },
        { dialCode: "+998", code: "UZ" },
        { dialCode: "+678", code: "VU" },
        { dialCode: "+58", code: "VE" },
        { dialCode: "+84", code: "VN" },
        { dialCode: "+1284", code: "VG" },
        { dialCode: "+1340", code: "VI" },
        { dialCode: "+681", code: "WF" },
        { dialCode: "+967", code: "YE" },
        { dialCode: "+260", code: "ZM" },
        { dialCode: "+263", code: "ZW" },
      ]);
  }
  firstUpdated(e) {
    let i = JSON.parse(localStorage.getItem("consent")).country;
    if (i) {
      let s = this.countryCodes.find((t) => t.code === i);
      s && ((this.selectedCode = s.code), (this.selectedDialCode = s.dialCode));
    }
  }
  onChange(e, i) {
    const s = e.target;
    if (s && this.validate) {
      let { valid: t, message: a, type: r } = this.validate(s.value);
      !t && r === "all"
        ? (this.error = a)
        : !t && i === r
        ? (this.error = a)
        : (this.error = void 0);
    }
    (this.phoneNumber = s.value),
      this.dispatchEvent(
        new CustomEvent("input--changed", {
          bubbles: !0,
          composed: !0,
          detail: {
            event: {
              ...e,
              target: { ...e.target, value: this.selectedDialCode + s.value },
            },
          },
        })
      );
  }
  onCodeChange(e) {
    const i = e.target;
    console.log("select.value", i.value);
    let s = this.countryCodes.find((t) => t.code === i.value).dialCode;
    (this.selectedCode = i.value),
      (this.selectedDialCode = s),
      this.dispatchEvent(
        new CustomEvent("input--changed", {
          bubbles: !0,
          composed: !0,
          detail: {
            event: {
              ...e,
              target: { ...e.target, value: s + this.phoneNumber },
            },
          },
        })
      );
  }
};
b([n()], C.prototype, "validate");
b([n()], C.prototype, "name");
b([n()], C.prototype, "value");
b([n()], C.prototype, "placeholder");
b([n({ type: Number })], C.prototype, "maxLength");
b([n({ type: Boolean })], C.prototype, "isEnable");
b([n({ type: Boolean })], C.prototype, "showErrorText");
b([p()], C.prototype, "error");
b([p()], C.prototype, "phoneNumber");
b([p()], C.prototype, "selectedCode");
b([p()], C.prototype, "selectedDialCode");
b([p()], C.prototype, "countryCodes");
var Si = Object.defineProperty,
  Di = Object.getOwnPropertyDescriptor,
  xi = (o, e, i, s) => {
    for (
      var t = s > 1 ? void 0 : s ? Di(e, i) : e, a = o.length - 1, r;
      a >= 0;
      a--
    )
      (r = o[a]) && (t = (s ? r(e, i, t) : r(t)) || t);
    return s && t && Si(e, i, t), t;
  };
let Je = class extends C {
  render() {
    return l`
      <field-wrapper-component
        .name=${this.name}
        .error=${this.showErrorText ? this.error : void 0}
      >
        <div class="wrapper">
          <select class="input" @change=${this.onCodeChange}>
            ${this.countryCodes.map(
              (o) => l`<option
                  value=${o.code}
                  ?selected=${o.code === this.selectedCode}
                >
                  ${o.code} (${o.dialCode})
                </option>`
            )}
          </select>
          <input
            type="tel"
            class="input"
            .value=${this.value}
            @input=${(o) => this.onChange(o, "input")}
            @blur=${(o) => this.onChange(o, "blur")}
            placeholder=${this.placeholder}
            title=${this.name}
          />
        </div>
      </field-wrapper-component>
    `;
  }
  static get styles() {
    return [
      y,
      g`
        .wrapper {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          gap: 1rem;
        }
        .input {
          padding-top: 0.5rem;
          padding-bottom: 0.25rem;
          font-size: var(--fontSizeBig);
          border: none;
          border-bottom: solid 1px #000;
          outline: none;
        }
        input {
          width: 100%;
        }
        select {
          width: 9ch;
          background-color: transparent;
          text-overflow: ellipsis;
          cursor: pointer;
        }
        select:active {
          background-color: #cccccc;
        }
        .error {
          border-color: red;
          outline-color: red;
        }
      `,
    ];
  }
};
Je = xi([$("phone-number-input-component")], Je);
const Pi = (o) => l`
  <div class="container">
    ${
      o.SDKManager
        ? l`
          <calendar-component
            .calendar=${o.calendar}
            .sesami=${o.SDKManager[o.selectedSDK].SDK}
            .selectedSDK=${o.selectedSDK}
          ></calendar-component>
        `
        : "loading"
    }
  </div>
`;
let Ai = class {};
const Ei = [
  y,
  g`
    .container {
      display: flex;
      height: 100%;
    }
    calendar-component {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  `,
];
var Oi = Object.defineProperty,
  Mi = Object.getOwnPropertyDescriptor,
  Ti = (o, e, i, s) => {
    for (
      var t = s > 1 ? void 0 : s ? Mi(e, i) : e, a = o.length - 1, r;
      a >= 0;
      a--
    )
      (r = o[a]) && (t = (s ? r(e, i, t) : r(t)) || t);
    return s && t && Oi(e, i, t), t;
  };
let Qe = class extends ne {
  constructor() {
    super(), (this.logic = new Ai());
  }
  connectedCallback() {
    super.connectedCallback();
  }
  render() {
    return Pi(this);
  }
  static get styles() {
    return Ei;
  }
};
Qe = Ti([$("calendar-page")], Qe);
var Ni = Object.defineProperty,
  I = (o, e, i, s) => {
    for (var t = void 0, a = o.length - 1, r; a >= 0; a--)
      (r = o[a]) && (t = r(e, i, t) || t);
    return t && Ni(e, i, t), t;
  };
let M = class extends m {
  constructor() {
    super(...arguments),
      (this.selectedSDK = 0),
      (this.SDKManager = []),
      (this.form = {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        note: "",
        guests: 1,
      }),
      (this.selectedDate = ""),
      (this.selectedTime = ""),
      (this.maxCounterNumber = 3);
  }
};
I([n({ type: Number })], M.prototype, "selectedSDK");
I([n({ type: Array })], M.prototype, "SDKManager");
I([n()], M.prototype, "calendar");
I([p()], M.prototype, "form");
I([p()], M.prototype, "selectedDate");
I([p()], M.prototype, "selectedTime");
I([p()], M.prototype, "maxCounterNumber");
const Ki = (o) => l`
  <div class="Form">
    <div class="wrapper">
      <div class="inputs">
        <input-field-component
          name="Email"
          .validate=${o.logic.validateEmail}
          placeholder="whisky@sullivanscove.com"
          .value=${o.form.email}
          @input--changed=${(e) => o.onChange(e, "email")}
        ></input-field-component>

        <input-field-component
          name="First name"
          .validate=${o.logic.validateFirstName}
          placeholder="Myrtle"
          .value=${o.form.firstName}
          @input--changed=${(e) => o.onChange(e, "firstName")}
        ></input-field-component>

        <input-field-component
          name="Last Name"
          .validate=${o.logic.validateLastName}
          placeholder="Sullivan"
          .value=${o.form.lastName}
          @input--changed=${(e) => o.onChange(e, "lastName")}
        ></input-field-component>

        <phone-number-input-component
          name="Phone Number"
          .validate=${o.logic.validatePhone}
          placeholder="0400 123 456"
          .value=${o.form.phone}
          @input--changed=${(e) => o.onChange(e, "phone")}
        ></phone-number-input-component>

        <counter-component
          name="number of guests"
          .value=${o.form.guests}
          .maxCount=${o.maxCounterNumber}
          @input--changed=${(e) => o.onChange(e, "guests")}
        ></counter-component>
      </div>
      <div class="summary">
        <h3>summary</h3>
        <div>
          <span>${o.SDKManager[o.selectedSDK].name}</span>
          <span>${o.selectedDate}</span>
          <span>${o.selectedTime}</span>
        </div>
        <div>
          <span>Sullivans Cove Distillery</span>
          <span>1/10 Lamb Place</span>
          <span>Cambridge TAS 7170</span>
        </div>
      </div>
      <div class="note">
        <h3>Booking notes</h3>
        <textarea
          .value=${o.form.note}
          @input=${(e) => o.onChangeForNote(e)}
        ></textarea>
        <span
          >Let us know about any non-drinkers attending or anything else you'd
          like us to know ahead of time.</span
        >
      </div>
    </div>
  </div>
`;
let Li = class {
  validateForm(e) {
    let i = !0;
    const s = this.validateEmail(e.email);
    i = i && s.valid;
    const t = this.validateFirstName(e.firstName);
    i = i && t.valid;
    const a = this.validateLastName(e.lastName);
    i = i && a.valid;
    const r = this.validatePhone(e.phone);
    return (i = i && r.valid), { valid: i };
  }
  validateEmail(e) {
    const i = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return e.length < 1
      ? { valid: !1, message: "Email is required.", type: "blur" }
      : i.test(e)
      ? { valid: !0, message: "", type: "all" }
      : { valid: !1, message: "Email is not valid.", type: "blur" };
  }
  validateFirstName(e) {
    return e.length < 1
      ? { valid: !1, message: "First name is required.", type: "blur" }
      : e.length > 50
      ? { valid: !1, message: "First name is too large.", type: "all" }
      : { valid: !0, message: "", type: "all" };
  }
  validateLastName(e) {
    return e.length < 1
      ? { valid: !1, message: "Last name is required.", type: "blur" }
      : e.length > 50
      ? { valid: !1, message: "Last name is too large.", type: "all" }
      : { valid: !0, message: "", type: "all" };
  }
  validatePhone(e) {
    const i = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g;
    if (e.length < 1)
      return { valid: !1, message: "Phone number is required.", type: "blur" };
    if (i.test(e)) {
      if (e.length > 20)
        return { valid: !1, message: "Phone number is too large", type: "all" };
    } else
      return { valid: !1, message: "Phone number is not valid", type: "blur" };
    return { valid: !0, message: "", type: "all" };
  }
};
const zi = [
  y,
  g`
    .Form {
      width: 100%;
      height: 100%;
      padding: 2rem 0;
    }
    .wrapper {
      width: 100%;
      height: 90%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }
    .inputs {
      width: 65%;
      display: flex;
      flex-direction: column;
      gap: 2rem;
      justify-content: space-between;
    }
    .summary {
      width: 30%;
      height: 70%;
      background-color: var(--secondaryColor);
      font-size: var(--fontSizeMid);
      padding: 2rem 1rem;
      display: flex;
      flex-direction: column;
      gap: 3rem;
      color: #000;
    }
    .summary h3 {
      text-transform: uppercase;
      font-weight: 600;
      letter-spacing: 2px;
      font-family: var(--sctype-spezia-extended);
    }
    .summary div {
      display: flex;
      flex-direction: column;
      gap: 0.7rem;
    }
    .note {
      width: 100%;
      padding-top: 2rem;
      color: #000;
    }
    .note h3 {
      font-size: var(--fontSizeMid);
      text-transform: uppercase;
      padding-bottom: 0.25rem;
      font-family: var(--sctype-spezia-extended);
    }
    .note span {
      font-size: var(--fontSizeSmall);
    }
    .note textarea {
      width: 100%;
      resize: none;
      height: 5rem;
      font-size: var(--fontSizeMid);
      padding: 0.5rem;
    }
    @media (max-width: 600px) {
      .Form {
        padding: 0;
      }
      .wrapper {
        flex-direction: column;
      }
      .inputs,
      .summary {
        width: 100%;
      }

      .inputs {
        order: 2;
      }
      .summary {
        order: 1;
        padding: 0 1rem;
        gap: 1rem;
        margin: 1rem 0;
        padding: 1rem 1.5rem;
      }
      .summary div {
        gap: 0.5rem;
      }
      .summary div:nth-child(3) {
        display: none;
      }
      .note {
        order: 3;
      }
    }
  `,
];
var ji = Object.defineProperty,
  Ui = Object.getOwnPropertyDescriptor,
  Ii = (o, e, i, s) => {
    for (
      var t = s > 1 ? void 0 : s ? Ui(e, i) : e, a = o.length - 1, r;
      a >= 0;
      a--
    )
      (r = o[a]) && (t = (s ? r(e, i, t) : r(t)) || t);
    return s && t && ji(e, i, t), t;
  };
let Xe = class extends M {
  constructor() {
    super(), (this.logic = new Li());
  }
  connectedCallback() {
    super.connectedCallback();
  }
  firstUpdated(e) {
    let i = this.calendar.slot.startTime.replace(" ", "T"),
      { selectedDate: s, selectedTime: t } = xe(
        new Date(i),
        this.calendar.slot.duration
      );
    (this.selectedDate = s),
      (this.selectedTime = t),
      (this.maxCounterNumber = this.calendar.slot.remainingSlots);
  }
  onChange(e, i) {
    const { event: s } = e.detail,
      t = s.target;
    this.form[i] = t.value;
    let { valid: a } = this.logic.validateForm(this.form);
    this.dispatchEvent(
      new CustomEvent("setPageData", {
        bubbles: !0,
        composed: !0,
        detail: { pageData: { valid: a, formData: this.form }, page: "form" },
      })
    );
  }
  onChangeForNote(e) {
    const i = e.target;
    (this.form.note = i.value),
      this.dispatchEvent(
        new CustomEvent("setPageData", {
          bubbles: !0,
          composed: !0,
          detail: { pageData: { formData: this.form }, page: "form" },
        })
      );
  }
  render() {
    return Ki(this);
  }
  static get styles() {
    return zi;
  }
};
Xe = Ii([$("form-page")], Xe);
var Bi = Object.defineProperty,
  B = (o, e, i, s) => {
    for (var t = void 0, a = o.length - 1, r; a >= 0; a--)
      (r = o[a]) && (t = r(e, i, t) || t);
    return t && Bi(e, i, t), t;
  };
class T extends m {
  constructor() {
    super(...arguments),
      (this.selectedSDK = 0),
      (this.SDKManager = []),
      (this.selectedDate = ""),
      (this.selectedDateWithoutYear = ""),
      (this.selectedTime = "");
  }
}
B([n({ type: Number })], T.prototype, "selectedSDK");
B([n({ type: Array })], T.prototype, "SDKManager");
B([n()], T.prototype, "calendar");
B([n()], T.prototype, "form");
B([p()], T.prototype, "selectedDate");
B([p()], T.prototype, "selectedDateWithoutYear");
B([p()], T.prototype, "selectedTime");
const Hi = (o) => l`
  <div class="final">
    <h2 class="title">See you soon</h2>
    <p>
      Thank you for your booking. We look forward to seeing you at our cellar
      door on ${o.selectedDateWithoutYear}. You should receive an email
      shortly confirming the details of your visit.
    </p>
    <div class="event">
      <span>${o.SDKManager[o.selectedSDK].name}</span>
      <span>${o.selectedDate}</span>
      <span>${o.selectedTime}</span>
    </div>
    <div class="inputs">
      <div class="inputs-section">
        <span>email:</span>
        <span> ${o.form.formData.email} </span>
      </div>
      <div class="inputs-section">
        <span>name:</span>
        <span>
          ${o.form.formData.firstName} ${o.form.formData.lastName}
        </span>
      </div>
      <div class="inputs-section">
        <span>phone:</span>
        <span> ${o.form.formData.phone} </span>
      </div>
      <div>booking for ${o.form.formData.guests} guests</div>
    </div>
  </div>
`;
let Ri = class {};
const Fi = [
  y,
  g`
    .final {
      font-size: var(--fontSizeMid);
      display: flex;
      flex-direction: column;
      gap: 3rem;
      margin: 5rem 0;
    }
    .event,
    .inputs {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
    }
    .inputs div {
      display: flex;
    }
    .inputs-section span:nth-child(1) {
      font-weight: 600 !important;
    }
    .inputs-section span:nth-child(2) {
      padding-left: 3px !important;
    }
    .title {
      font-size: var(--fontSizeExtra);
      text-transform: uppercase;
    }
  `,
];
var ki = Object.defineProperty,
  Gi = Object.getOwnPropertyDescriptor,
  Vi = (o, e, i, s) => {
    for (
      var t = s > 1 ? void 0 : s ? Gi(e, i) : e, a = o.length - 1, r;
      a >= 0;
      a--
    )
      (r = o[a]) && (t = (s ? r(e, i, t) : r(t)) || t);
    return s && t && ki(e, i, t), t;
  };
let et = class extends T {
  constructor() {
    super(), (this.logic = new Ri());
  }
  connectedCallback() {
    super.connectedCallback();
  }
  firstUpdated(e) {
    let i = this.calendar.slot.startTime.replace(" ", "T"),
      {
        selectedDate: s,
        selectedTime: t,
        selectedDateWithoutYear: a,
      } = xe(new Date(i), this.calendar.slot.duration);
    (this.selectedDate = s),
      (this.selectedDateWithoutYear = a),
      (this.selectedTime = t);
  }
  render() {
    return Hi(this);
  }
  static get styles() {
    return Fi;
  }
};
et = Vi([$("final-page")], et);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const Wi = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6,
  },
  Yi =
    (o) =>
    (...e) => ({ _$litDirective$: o, values: e });
class qi {
  constructor(e) {}
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AT(e, i, s) {
    (this._$Ct = e), (this._$AM = i), (this._$Ci = s);
  }
  _$AS(e, i) {
    return this.update(e, i);
  }
  update(e, i) {
    return this.render(...i);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class ye extends qi {
  constructor(e) {
    if ((super(e), (this.it = u), e.type !== Wi.CHILD))
      throw Error(
        this.constructor.directiveName + "() can only be used in child bindings"
      );
  }
  render(e) {
    if (e === u || e == null) return (this._t = void 0), (this.it = e);
    if (e === z) return e;
    if (typeof e != "string")
      throw Error(
        this.constructor.directiveName + "() called with a non-string value"
      );
    if (e === this.it) return this._t;
    this.it = e;
    const i = [e];
    return (
      (i.raw = i),
      (this._t = {
        _$litType$: this.constructor.resultType,
        strings: i,
        values: [],
      })
    );
  }
}
(ye.directiveName = "unsafeHTML"), (ye.resultType = 1);
const Zi = Yi(ye),
  Ji = (o) => l`
    <div class="experience">
      <div class="hero">
        ${o.data.services.map(
          (e, i) => l`
            <div class="heroCard">
              <img src=${e.image} />
              <h2>${e.name}</h2>
              <p>${Zi(e.description)}</p>
              <div
                class="button button-fill"
                @click=${() => o.selectSDK(i)}
              >
                ${e.tabName}
              </div>
            </div>
          `
        )}
      </div>

      ${
        o.isPopUpOpen
          ? l`<div class="popUp">
            <div class="container">
              <header-component
                class=${
                  o.currentIndex === 0
                    ? "selection-active"
                    : "selection-deactivate"
                }
                .currentIndex=${o.currentIndex}
                .data=${o.data}
                .selectedSDK=${o.selectedSDK}
                .selectSDK=${o.selectSDK.bind(o)}
                .close=${o.close.bind(o)}
              ></header-component>
              <div
                @setPageData=${(e) => o.handlePageData(e)}
                class="page"
              >
                ${
                  o.currentIndex === 0
                    ? l`<calendar-page
                      .SDKManager=${o.SDKManager}
                      .selectedSDK=${o.selectedSDK}
                      .calendar=${o.calendar}
                    ></calendar-page>`
                    : o.currentIndex === 1
                    ? l`<form-page
                      .SDKManager=${o.SDKManager}
                      .selectedSDK=${o.selectedSDK}
                      .calendar=${o.calendar}
                    ></form-page>`
                    : l`<final-page
                      .SDKManager=${o.SDKManager}
                      .selectedSDK=${o.selectedSDK}
                      .calendar=${o.calendar}
                      .form=${o.form}
                    ></final-page>`
                }
              </div>
              <navigation-component
                .navigateTo=${o.navigateTo.bind(o)}
                .currentIndex=${o.currentIndex}
                .calendar=${o.calendar}
                .form=${o.form}
                .confirm=${o.confirm.bind(o)}
                .close=${o.close.bind(o)}
              ></navigation-component>
            </div>
          </div>`
          : ""
      }
    </div>
  `;
class Qi {
  validateNavigation({ direction: e, pageNumber: i }, s, t) {
    return (
      e !== void 0
        ? (t = Math.min(Math.max(0, t + Math.sign(e)), s - 1))
        : i !== void 0 && i >= 0 && i < s && (t = i),
      t
    );
  }
  async init(e, i = 5e3) {
    if (window.SesamiSDK) return this.initializeSDK(e);
    try {
      return await this.waitForSDK(i), this.initializeSDK(e);
    } catch (s) {
      console.error("SesamiSDK failed to load within the timeout period.", s);
    }
  }
  waitForSDK(e) {
    return new Promise((s, t) => {
      const a = setInterval(() => {
        window.SesamiSDK && (clearInterval(a), s());
      }, 100);
      setTimeout(() => {
        clearInterval(a), t(new Error("Timeout: SesamiSDK not available."));
      }, e);
    });
  }
  async initializeSDK(e) {
    if (!window.SesamiSDK) throw new Error("SesamiSDK is not available.");
    const i = new window.SesamiSDK(e);
    return i.init(), { SDK: i };
  }
}
const Xi = [
  y,
  g`
    .experience {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 5rem 0;
    }
    .hero {
      width: 144rem;
      height: 100%;
      display: flex;
      justify-content: space-evenly;
      padding: 0 5rem;
      overflow: hidden;
      gap: 0.5rem;
      .button {
        width: fit-content;
      }
    }
    .heroCard {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      gap: 3rem;
      width: 50%;
      background-color: #f3f1ee;
      padding: 2.5rem;
      max-height: 100%;
      min-height: 100%;
    }
    .heroCard img {
      width: 60%;
      height: auto;
    }
    .popUp {
      background-color: rgba(0, 0, 0, 0.4);
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 999;
    }
    .container {
      width: 50%;
      max-width: 1280px;
      max-height: 90%;
      background-color: #fff;
      padding: 4rem;
      padding-top: 2rem;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      overflow-y: auto;
    }
    .page {
      width: 100%;
      flex: 1;
    }
    header-component {
      height: 5rem;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
    }
    navigation-component {
      margin-top: 2rem;
    }
    @media (min-width: 2000px) {
      header-component {
        height: 7rem;
      }
    }
    @media (max-width: 1600px) {
      .container {
        width: 60%;
      }
    }
    @media (max-width: 600px) {
      navigation-component {
        margin-top: 0rem;
      }
      .hero {
        flex-direction: column;
        align-items: unset;
        justify-content: unset;
        gap: 2rem;
        padding: 0 2rem;
      }
      .heroCard {
        align-items: center;
        justify-content: space-between;
        text-align: center;
        width: 100%;
      }
      .selection-deactivate {
        height: 12vh !important;
      }
      .selection-active {
        height: 15vh !important;
      }
      .popUp {
        overflow-y: scroll;
        align-items: unset;
        justify-content: unset;
      }
      .container {
        width: 100%;
        height: fit-content;
        min-height: 100%;
        padding: 3rem;
        justify-content: flex-start;
        gap: 2.5rem;
      }
      .page {
        flex: unset;
      }
    }
  `,
];
var eo = Object.defineProperty,
  to = Object.getOwnPropertyDescriptor,
  io = (o, e, i, s) => {
    for (
      var t = s > 1 ? void 0 : s ? to(e, i) : e, a = o.length - 1, r;
      a >= 0;
      a--
    )
      (r = o[a]) && (t = (s ? r(e, i, t) : r(t)) || t);
    return s && t && eo(e, i, t), t;
  };
let tt = class extends O {
  constructor() {
    super(), (this.logic = new Qi());
  }
  connectedCallback() {
    super.connectedCallback(), this.initialSDK();
  }
  handlePageData(e) {
    const { pageData: i, page: s } = e.detail;
    s === "calendar"
      ? (this.calendar = { ...this.calendar, ...i })
      : s === "form" && (this.form = { ...this.form, ...i });
  }
  async initialSDK() {
    this.data.services.map(async (e) => {
      let i = { ...e, shopId: this.data.shopId, quantity: 1, autoLoad: !0 },
        { SDK: s } = await this.logic.init(i);
      this.SDKManager.push({ name: e.name, SDK: s });
    });
  }
  close() {
    (this.isPopUpOpen = !1),
      (this.currentIndex = 0),
      (this.calendar = void 0),
      (this.form = void 0),
      (this.selectedSDK = null);
  }
  selectSDK(e) {
    this.selectedSDK !== e &&
      ((this.calendar = void 0),
      (this.form = void 0),
      (this.isPopUpOpen = !0),
      (this.selectedSDK = e));
  }
  async navigateTo({ direction: e, pageNumber: i }) {
    this.currentIndex = this.logic.validateNavigation(
      { direction: e, pageNumber: i },
      3,
      this.currentIndex
    );
  }
  confirm() {
    var i, s;
    if (this.selectedSDK === null || !this.form) return;
    let e = {
      properties: [
        {
          name: "note",
          value: (i = this.form) == null ? void 0 : i.formData.note,
        },
      ],
    };
    (this.SDKManager[this.selectedSDK].SDK.quantity =
      this.form.formData.guests),
      this.SDKManager[this.selectedSDK].SDK.book(
        (s = this.calendar) == null ? void 0 : s.slot,
        this.form.formData,
        e
      )
        .then(() => {
          this.navigateTo({ direction: 1 });
        })
        .catch((t) => {
          console.table(t);
        });
  }
  render() {
    return Ji(this);
  }
  static get styles() {
    return Xi;
  }
};
tt = io([$("wrapper-component")], tt);
var oo = Object.defineProperty,
  so = Object.getOwnPropertyDescriptor,
  lt = (o, e, i, s) => {
    for (
      var t = s > 1 ? void 0 : s ? so(e, i) : e, a = o.length - 1, r;
      a >= 0;
      a--
    )
      (r = o[a]) && (t = (s ? r(e, i, t) : r(t)) || t);
    return s && t && oo(e, i, t), t;
  };
let Ce = class extends m {
  render() {
    return l`
      <div>
        ${
          this.data
            ? l`<wrapper-component .data=${this.data}></wrapper-component>`
            : "waiting for data + " + JSON.stringify(this.data)
        }
      </div>
    `;
  }
  static get styles() {
    return [
      y,
      g`
        wrapper-component {
          position: relative;
        }
      `,
    ];
  }
};
lt([n({ type: Object })], Ce.prototype, "data", 2);
Ce = lt([$("booking-experience")], Ce);
